import { Component, OnInit, computed, signal, inject } from '@angular/core';
import { BoFormsModule } from '@bo/ng-forms';
import { AvatarComponent } from '../../../../../shared/components/avatar/avatar.component';
import { CardsApiService } from '../../../../../_services/cards-service/cards-api/cards-api.service';
import { ActivatedRoute } from '@angular/router';
import { Card, CardBalance, CardStatus } from '../../../../../_interfaces/cards.interface';
import { ViewCardComponent } from '../../../../../shared/components/cards/view-card/view-card.component';
import { of, Subscription, tap } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { LoaderComponent } from '../../../../../shared/components/loader/loader.component';

@Component({
  selector: 'app-view-subscription-cards',
  imports: [BoFormsModule, AvatarComponent, ViewCardComponent, LoaderComponent],
  templateUrl: './subscription-card-detail.component.html',
})
export class SubscriptionCardDetailComponent implements OnInit {
  readonly route = inject(ActivatedRoute);
  readonly cardsApiService = inject(CardsApiService);

  private readonly cardId: number;
  protected cardDetail = signal<Card>({} as Card);
  private readonly realtimeBalance = signal<CardBalance | null>(null);
  protected cardBalance = computed<CardBalance>(
    () => this.realtimeBalance() ?? { balance: this.cardDetail().balance ?? '' },
  );
  readonly subscriptions = new Subscription();

  constructor() {
    const route = this.route;

    this.cardId = route.snapshot.params['id'];
  }

  ngOnInit(): void {
    this.loadSubscriptionCardDetails();
  }

  loadSubscriptionCardDetails() {
    if (!this.cardId) return;
    this.subscriptions.add(
      this.cardsApiService
        .getSubscriptionCardById(this.cardId)
        .pipe(
          tap((card) => this.cardDetail.set(card)),
          switchMap((card) => {
            if (card.status === CardStatus.New) {
              return of(null);
            } else {
              return this.cardsApiService.getSubscriptionCardBalance(this.cardId);
            }
          }),
        )
        .subscribe({
          next: (balance: CardBalance | null) => {
            if (balance) {
              this.realtimeBalance.set(balance);
            }
          },
          error: (err) => console.error('Error loading card details/balance', err),
        }),
    );
  }
}
